import React, { useContext, useEffect, useState } from "react";
import { globalVariables } from "helper/globalVariables";
import {
  Member,
  CalendarIcon,
  CheckVerified,
  ClockRewind,
  Logout,
  logo,
  avatar,
  SwitchRole,
} from "helper/images";
import { Magnifier } from "helper/icons";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import {
  setAuthToken,
  setOriginalRoleAction,
  setRoleAction,
  setUser,
} from "redux/features/authSlice/AuthSlice";
import {
  setHostDetails,
  setTrialDetails,
} from "redux/features/hostSlice/addTrialSlice/addTrialSlice";
import { setMemberDetails } from "redux/features/memberSlice/memberSlice";
import { RoleContext } from "context/RoleContext";

export const SideNav = (props) => {
  const [switchRoleInActive, setswitchRoleInActive] = useState(false);
  const route = useLocation();
  const dispatch = useDispatch();
  const { auth } = useSelector((state) => state);
  const { profile, first_name, last_name } =
    auth?.memberReducer?.memberDetails || {};
  const role = useContext(RoleContext);
  const params = new URLSearchParams(window.location.search);
  const option = params.get("option");

  console.log("option===", option, route.pathname, role);

  const sideNavData = [
    {
      icon: <Member className="h-6 w-6 mr-3" />,
      label: globalVariables.myDashboard,
      navigate: "/dashboard/memberDashboard",
    },
    {
      icon: <CalendarIcon className="h-6 w-6 mr-3" />,
      label: globalVariables.trialCalendar,
      navigate: "/dashboard/trialCalendar",
    },
    {
      icon: <CheckVerified className="h-6 w-6 mr-3" />,
      label: globalVariables.trialResults,
      navigate: "/dashboard/trialResults",
    },
    {
      icon: <ClockRewind className="h-6 w-6 mr-3" />,
      label: globalVariables.dogHistory,
      navigate: "/dashboard/dogHistory",
    },
    {
      icon: <Magnifier className="h-6 w-6 mr-3" />,
      label: globalVariables.viewEntries,
      navigate: "/dashboard/viewEntries",
    },
    {
      icon: <SwitchRole className="h-6 w-6 mr-3" />,
      label: "Switch-Roles",
      navigate: "/dashboard/switchRole?option=switchRole",
      active: "/dashboard/myProfile?option=switchRole",
    },
  ];

  const { menuItems = sideNavData, profileRoute, noProfile } = props || {};

  useEffect(() => {
    if (option === "switchRole") {
      setswitchRoleInActive(true);
    } else {
      setswitchRoleInActive(false);
    }
  }, [sideNavData, route.pathname]);

  useEffect(() => {
    console.log("menuItems Includes", menuItems[0].navigate);
    console.log("route.pathname", route.pathname);
    console.log(route.pathname.includes(menuItems[0].navigate));
  }, [menuItems]);

  const onLogout = () => {
    dispatch(setUser(null));
    dispatch(setAuthToken(""));
    dispatch(setMemberDetails(null));
    dispatch(setHostDetails(null));
    dispatch(setTrialDetails(null));
    dispatch(setRoleAction(""));
    dispatch(setOriginalRoleAction(""));
  };

  const ProfileComponent = () => {
    const [profileImg, setProfileImg] = useState(profile);

    useEffect(() => {
      setProfileImg(profile);
    }, [profile]);

    return (
      <>
        <img
          src={profileImg ? profileImg : avatar}
          alt=""
          className="h-10 w-10 mr-3 border rounded-[50px]"
          onError={() => {
            setProfileImg(avatar);
          }}
        />
        <div className="flex flex-col mr-6">
          <p className="text-sm font-semibold text-white w-36 break-all">{`${first_name} ${last_name}`}</p>
          {/* <p className="text-sm font-redular text-purple-900 w-36 break-all">
            {email}
          </p> */}
          <p className="text-sm font-redular text-white w-36 break-all">
            {role}
          </p>
        </div>
      </>
    );
  };


  return (
    <div
      className="fixed bg-100 h-full text-white"
      style={{ width: "280px"}}
    > 
      <div className="cursor-pointer bg-white py-4 ml-4 border-lt rounded-lg mr-[-10px]">
        <a href="https://www.k9scentgames.fun" target="_blank" rel="noopener noreferrer">
          <img src={logo} alt="Logo" className="h-15 w-32 ml-3" />
        </a>
      </div>
      <div className="py-8 px-4 h-[72vh] overflow-y-scroll">
        <ul>
          {menuItems.map((data, index) => (
            <li
              key={data.label}
              className={`mb-1 py-2 px-3 h-10 cursor-pointer hover:bg-lightBlue  text-white rounded-md font-semibold ${
                (route.pathname.includes(data?.active?.includes) &&
                  switchRoleInActive) ||
                route.pathname.includes(data.navigate)
                  ? "bg-lightBlue"
                  : ""
              } `}
            >
              <Link to={data.navigate}>
                <div className="flex flex-row">
                  {data.icon}
                  <span>{data.label}</span>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="absolute self-center flex flex-row bottom-8 pt-6 mx-4 px-2">
        {noProfile ? (
          <div className="flex">
            <ProfileComponent />
          </div>
        ) : (
          <Link
            to={profileRoute ? profileRoute : "/dashboard/myProfile"}
            className="flex"
          >
            <ProfileComponent />
          </Link>
        )}

        <button type="button" onClick={onLogout}>
          <Logout />
        </button>
      </div>
    </div>
  );
};
